<template>
  <MetricCircle
    :value='score'
    :label='label'
    :icon='icon'
    :name='name'
    :small='small'
  />
</template>

<script>
import User from '@/models/user'
import MetricCircle from '@/components/MetricCircle'

export default {
  name: 'MetricSleepQuality',
  props: {
    dateFrom: String,
    dateTo: String,
    hideLabel: Boolean,
    hideName: Boolean,
    small: Boolean,
  },
  components: {
    MetricCircle,
  },
  data() {
    return {
      score: undefined,
      label: undefined,
      icon: 'metric_quality.png', //'🌟',
      name: this.hideName ? undefined : 'Efficiency',
    }
  },
  beforeMount() {
    this.loadMetric()
  },
  watch: {
    // TODO: Also watch `dateTo` when implementing date range picker.
    dateFrom() {
      this.loadMetric()
    },
   },
  methods: {
    async loadMetric() {
      if (!this.dateFrom || !this.dateTo) return
      const user = await User.getCurrentUser()
      const quality = await user.getSleepQualityScore(this.dateFrom, this.dateTo)
      this.score = Math.round(quality.score * 100)
      this.label = this.hideLabel ? undefined : Math.round(quality.score * 100) + '%'
    }
  },
}
</script>